<template>
  <div class="container-fluid">
    <div class="row mb-0">
      <div class="col-12">
        <b-form-group label="" class="mb-0">
          <b-form-checkbox-group v-model="selectedSites" @change="saveSettings">
            <b-form-checkbox
              v-for="site in sites"
              :key="site.name"
              :value="site.name"
              inline
            >
              {{ site.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div :class="[columnClass, 'mb-3']" v-for="site in visibleSites" :key="site.name">
        <div class="border rounded p-1 h-100">
          <div class="small text-muted mb-1">{{ site.name }}</div>
          <iframe class="cmp-frame" :src="site.url"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SentimentPopularCompare',
  data() {
    return {
      selectedSites: [],
      sites: [
        { name: '同花顺热股', url: 'https://eq.10jqka.com.cn/frontend/thsTopRank' },
        { name: '通达信热度榜', url: 'https://pul.tdx.com.cn/site/app/gzhbd/tdx-topsearch/page-main.html' },
        { name: '东方财富', url: 'https://vipmoney.eastmoney.com/collect/app_ranking/ranking/app.html#/stock' },
        { name: '财联社', url: 'https://api3.cls.cn/quote/toplist' },
        { name: '雪球热股', url: 'https://xueqiu.com/hot/stock' }
      ]
    }
  },
  computed: {
    visibleSites() {
      return this.sites.filter(site => this.selectedSites.includes(site.name))
    },
    columnClass() {
      const count = this.visibleSites.length
      if (count === 1) return 'col-12'
      if (count === 2) return 'col-12 col-sm-6'
      if (count === 3) return 'col-12 col-sm-6 col-md-4'
      if (count === 4) return 'col-12 col-sm-6 col-lg-3'
      return 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2-4'
    }
  },
  created() {
    this.loadSettings()
  },
  methods: {
    saveSettings() {
      localStorage.setItem('sentiment_popular_compare_selection', JSON.stringify(this.selectedSites))
    },
    loadSettings() {
      try {
        const settings = localStorage.getItem('sentiment_popular_compare_selection')
        if (settings) {
          this.selectedSites = JSON.parse(settings)
        } else {
          // Default: all selected
          this.selectedSites = this.sites.map(s => s.name)
        }
      } catch (e) {
        console.error('Failed to load settings', e)
        // Fallback to all selected
        this.selectedSites = this.sites.map(s => s.name)
      }
    }
  }
}
</script>

<style scoped>
.cmp-frame {
  width: 100%;
  height: 1024px;
  border: none;
}

@media (min-width: 1200px) {
  .col-xl-2-4 {
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
